export var ActivityType = /*#__PURE__*/ function(ActivityType) {
    ActivityType["Login"] = "signin";
    ActivityType["JtwLogin"] = "signin-jwt";
    ActivityType["LoginFailed"] = "signin-failed";
    ActivityType["NewPasswordRequired"] = "new-password-required";
    ActivityType["SignUp"] = "sign-up";
    ActivityType["SignUpFailed"] = "sign-up-failed";
    ActivityType["Logout"] = "logout";
    ActivityType["OtpRequest"] = "opt-request";
    ActivityType["OtpVerification"] = "opt-verification";
    return ActivityType;
}({});
